import Vue from 'vue';
import VueAMap from 'vue-amap';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios';
import VueAxiosInit from 'plugins/vue-axios-init';
import VueAuthControl from 'plugins/vue-auth-control';
import 'static/iconfont/iconfont.css';
import 'static/css/reset.css';
import 'static/css/common.css';

import App from './App';
import store from './store';

Vue.use(ElementUI);
Vue.use(VueAMap);
Vue.use(VueAxiosInit, axios);
Vue.use(VueAuthControl);

const getProtocol = () => {
  const protocol = window.location.protocol;
  if (typeof protocol === 'string' && protocol.indexOf('https') >= 0) {
    return 'https';
  }
  return 'http';
};

VueAMap.initAMapApiLoader({
  key: 'f14b53ff8828b86585fa849ce39f8871',
  plugin: [
    'AMap.Scale',
    'AMap.OverView',
    'AMap.ToolBar',
  ],
  uiVersion: '1.0', // 高德UI组件库版本号
  v: '1.4.4',
  protocol: getProtocol(),
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/pages/homepage/index.js